import { DATA_SEARCH } from '../types'

export default (def = 'NULL', action) => {
    switch (action.type) {
        case DATA_SEARCH:
            return action.payload;
        default:
            return def;
    }
}